import { render, staticRenderFns } from "./ConcernCompaniesEmpty.vue?vue&type=template&id=4cc00486&scoped=true"
import script from "./ConcernCompaniesEmpty.vue?vue&type=script&lang=js"
export * from "./ConcernCompaniesEmpty.vue?vue&type=script&lang=js"
import style0 from "./ConcernCompaniesEmpty.vue?vue&type=style&index=0&id=4cc00486&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc00486",
  null
  
)

export default component.exports